import AccountPicker from "../../components/AccountPicker";
import { Plus, Trash2 } from "lucide-react";
import type { Account, Owner } from "../../types";

export interface GoalScheduleDraft {
  profile: string;
  accountId: string;
  monthlyAmount: string;
}

interface GoalScheduleFieldsProps {
  schedules: GoalScheduleDraft[];
  accounts: Account[];
  profiles: Owner[];
  currency: string;
  addSchedule: () => void;
  removeSchedule: (index: number) => void;
  updateSchedule: (index: number, field: keyof GoalScheduleDraft, value: string) => void;
}

export default function GoalScheduleFields({ schedules, accounts, profiles, currency, addSchedule, removeSchedule, updateSchedule }: GoalScheduleFieldsProps) {
  return (
        <div className="goal-form-section">
          <div className="goal-form-section-head">
            <span className="goal-form-section-title">
              Monthly commitments (auto-accrual)
            </span>
            <span className="goal-form-optional-tag">Optional</span>
          </div>
          <p className="goal-form-section-desc">
            Optional planned amounts saved from specific accounts each month.
          </p>

          {schedules.length === 0 ? (
            <button
              type="button"
              className="goal-add-commitment-trigger"
              onClick={addSchedule}
            >
              <Plus size={14} /> Add commitment
            </button>
          ) : (
            <>
              <div className="goal-schedules-list">
                {schedules.map((s, idx) => (
                  <div key={idx} className="goal-commitment-card">
                    <div className="goal-commitment-card-head">
                      <span className="goal-commitment-card-title">Commitment #{idx + 1}</span>
                      <button
                        type="button"
                        className="icon-button danger-icon-button"
                        onClick={() => removeSchedule(idx)}
                        aria-label="Remove commitment"
                      >
                        <Trash2 size={14} />
                      </button>
                    </div>

                    <div className="goal-commitment-fields">
                      <AccountPicker label="Account" accounts={accounts.filter(a => a.active !== false || a.id === s.accountId)} value={s.accountId} onChange={(id) => updateSchedule(idx, "accountId", id)} />

                      <label>
                        <span>Saved by</span>
                        <select
                          value={s.profile}
                          onChange={(e) => updateSchedule(idx, "profile", e.target.value)}
                        >
                          <option value="">Household</option>
                          {profiles.map((p) => (
                            <option key={p} value={p}>{p}</option>
                          ))}
                        </select>
                      </label>

                      <label className="goal-commitment-amount-field">
                        <span>Monthly amount ({currency})</span>
                        <input
                          type="text"
                          inputMode="decimal"
                          placeholder="e.g. 1000"
                          value={s.monthlyAmount}
                          onChange={(e) => updateSchedule(idx, "monthlyAmount", e.target.value)}
                        />
                      </label>
                    </div>
                  </div>
                ))}
              </div>

              <button
                type="button"
                className="small"
                onClick={addSchedule}
                style={{ alignSelf: "flex-start", marginTop: "0.25rem" }}
              >
                <Plus size={12} /> Add another commitment
              </button>
            </>
          )}
        </div>

  );
}
